import currencyFormatter from 'currencyformatter.js';

const currencyFormatters = {
	EUR: {
		postFormat() {
			const currencySymbol = currencyFormatter.symbols.EUR;
			const symbolLen = currencySymbol.length;
			const pattern = new RegExp(`(\\s)+${currencySymbol}`, 'g');
			let value = this.value;
			if (this.locale === 'fi_FI') {
				value = this.value.replace(pattern, currencySymbol);
			} else if (this.value.substr(-symbolLen, symbolLen) === currencySymbol) {
				value = this.value.replace(pattern, currencySymbol);
				value = currencySymbol + value.replace(currencySymbol, '');
			}
			return value;
		}
	},
	SEK: {
		locale: 'sv_SE'
	},
	NOK: {
		// show same as sek
		locale: 'sv_SE'
	},
	DKK: {
		locale: 'da_DK',
		postFormat() {
			if (this.value.charAt(this.value.length - 1) === '.') {
				return this.value.slice(0, -1);
			}
			return this.value;
		}
	},
	AUD: {
		locale: 'en_AU'
	},
	CAD: {
		locale: 'en_CA'
	},
	USD: {
		locale: 'en_US'
	},
	NZD: {
		locale: 'en_NZ'
	},
	GBP: {
		locale: 'en_GB'
	},
	CLP: {
		locale: 'en_GB',
		postFormat() {
			const currencySymbol = currencyFormatter.symbols.CLP;
			return this.value.replace(currencySymbol, `CLP${currencySymbol}`);
		}
	},
	PLN: {
		locale: 'pl_PL'
	},
	RUB: {
		locale: 'ru_RU',
		symbol: 'RUB'
	}
};


function format2(value, options) {
	// extend options
	const config = { value, ...options, ...currencyFormatters[options.currency] };

	// consolidate options for currency formatter
	const formatOptions = Object.assign({},
		config.currency && { currency: config.currency },
		config.symbol && { symbol: config.symbol },
		config.locale && { locale: config.locale === 'en_XX' ? 'en_GB' : config.locale }
	);

	config.value = currencyFormatter.format(value, formatOptions);
	if (config.postFormat) {
		config.value = config.postFormat.call(config);
	}
	return config.value;
}

function format(number, currency, locale) {
	let floatNumber = number;

	if (floatNumber === undefined || !currency) {
		return '';
	}

	if (typeof floatNumber === 'string') {
		floatNumber = parseFloat(floatNumber);
	}

	return format2(floatNumber, { currency, locale: locale.replace('-', '_') });
}

export default {
	format
};



// WEBPACK FOOTER //
// ./mobile-core/src/libs/currency-formatter.js